import React from "react";

const termsOfUseAppParagraphs = [
  "TERMS & CONDITIONS",
  "MYPREGA APPLICATION",
  "Operated By REMEDINART MEDICO SERVICES PRIVATE LIMITED",
  "Effective Date: [06/05/2026]",
  "PLEASE READ THESE TERMS & CONDITIONS CAREFULLY BEFORE ACCESSING, REGISTERING, OR USING THE MYPREGA APPLICATION (“PLATFORM” / “APPLICATION” / “SERVICES”). BY ACCESSING OR USING THE PLATFORM, THE USER (“USER” / “YOU”) AGREES TO BE LEGALLY BOUND BY THESE TERMS & CONDITIONS, THE PRIVACY POLICY, CONSENT TERMS, DISCLAIMERS, AND ALL APPLICABLE LAWS, INCLUDING THE DIGITAL PERSONAL DATA PROTECTION ACT, 2023 (“DPDP ACT”), INFORMATION TECHNOLOGY ACT, 2000, AND OTHER APPLICABLE INDIAN LAWS.",
  "IF THE USER DOES NOT AGREE TO THESE TERMS, THE USER MUST IMMEDIATELY DISCONTINUE USE OF THE PLATFORM.",
  "⸻",
  "1. NATURE OF PLATFORM",
  "1.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED operates the “Myprega ” brand and platform as a pregnancy wellness, educational, preventive care support, informational assistance, emotional wellness, tracking, and engagement platform.",
  "1.2 The Platform is intended solely for supportive, educational, wellness, informational, and engagement purposes and shall not be construed as a hospital, clinic, emergency medical service, diagnostic center, ambulance provider, intensive care provider, neonatal care provider, or substitute for physical medical consultation, diagnosis, treatment, or hospitalization.",
  "1.3 No content, recommendation, AI-generated response, expert communication, tracking insight, graph, notification, community discussion, educational material, or Garbhasanskar activity available on the Platform shall constitute medical diagnosis, prescription, treatment, emergency intervention, or guaranteed healthcare outcome.",
  "1.4 The User expressly acknowledges that all medical decisions, treatments, investigations, medications, emergency responses, hospital visits, consultations, pregnancy management decisions, labor management, and postpartum decisions shall remain solely under the responsibility of the User and the User’s treating licensed medical practitioner.",
  "⸻",
  "2. USER CONSENT",
  "2.1 By registering on the Platform, the User expressly provides free, informed, specific, unconditional, and affirmative consent for:",
  " (a) collection of personal data;",
  " (b) collection of sensitive personal health data;",
  " (c) storage, processing, analysis, profiling, handling, transmission, and use of such data;",
  " (d) generation of wellness insights and tracking analysis;",
  " (e) AI-assisted informational responses;",
  " (f) communication from authorized representatives of REMEDINART MEDICO SERVICES PRIVATE LIMITED.",
  "2.2 The User acknowledges and agrees that pregnancy-related data constitutes sensitive personal data and voluntarily consents to such processing under applicable laws including the DPDP Act, 2023.",
  "2.3 The User may withdraw consent subject to legal, contractual, operational, medical documentation, fraud prevention, and regulatory compliance requirements.",
  "⸻",
  "3. HEALTH DATA DISCLAIMER",
  "3.1 The User acknowledges that all health-related information entered into the Platform, including but not limited to blood pressure, blood sugar, pulse rate, temperature, fetal movement count, symptoms, weight, dietary information, medical history, medications, reports, scans, or wellness data, is voluntarily submitted by the User.",
  "3.2 The User shall remain solely responsible for:",
  " (a) accuracy of entered data;",
  " (b) correctness of medical readings;",
  " (c) timely updating of information;",
  " (d) usage of medically appropriate devices;",
  " (e) interpretation of their own medical condition through consultation with licensed medical practitioners.",
  "3.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be liable for:",
  " (a) inaccurate entries;",
  " (b) delayed updates;",
  " (c) incorrect measurements;",
  " (d) faulty devices;",
  " (e) technical inaccuracies;",
  " (f) syncing failures;",
  " (g) notification failures;",
  " (h) incorrect trend analysis resulting from inaccurate or incomplete data submitted by the User.",
  "3.4 Any tracking analysis, alerts, “red flag” notifications, graphs, warnings, AI-generated insights, wellness scores, or health indicators displayed on the Platform are automated system-generated supportive informational outputs and shall not be treated as confirmed medical findings, diagnosis, or emergency assessment.",
  "⸻",
  "4. EMERGENCY MEDICAL DISCLAIMER",
  "4.1 The Platform is NOT an emergency response system and shall not be used during medical emergencies.",
  "4.2 In case of severe bleeding, abdominal pain, chest pain, breathlessness, seizures, reduced fetal movement, labor emergencies, unconsciousness, hypertension-related symptoms, trauma, suicidal thoughts, severe mental distress, or any other medical emergency, the User shall immediately contact:",
  " (a) emergency medical services;",
  " (b) nearest hospital;",
  " (c) treating doctor;",
  " (d) ambulance services.",
  "4.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be responsible or liable for:",
  " (a) delayed emergency response;",
  " (b) failure by the User to seek timely medical care;",
  " (c) medical negligence by third-party healthcare providers;",
  " (d) maternal complications;",
  " (e) fetal complications;",
  " (f) hospitalization;",
  " (g) delay in diagnosis;",
  " (h) delay in treatment;",
  " (i) death or injury arising from delayed medical intervention and other complication.",
  "",
  "⸻",
  "5. LIMITATION OF LIABILITY",
  "5.1 To the fullest extent permissible under applicable law, REMEDINART MEDICO SERVICES PRIVATE LIMITED, Myprega , its directors, shareholders, officers, founders, employees, consultants, experts, medical advisors, affiliates, contractors, licensors, service providers, and representatives shall not be liable for any:",
  " (a) maternal injury;",
  " (b) maternal illness;",
  " (c) maternal death;",
  " (d) fetal injury;",
  " (e) fetal abnormalities;",
  " (f) congenital defects;",
  " (g) developmental defects;",
  " (h) miscarriage;",
  " (i) stillbirth;",
  " (j) premature delivery;",
  " (k) neonatal complications;",
  " (l) neonatal death;",
  " (m) labor complications;",
  " (n) emotional distress;",
  " (o) mental trauma;",
  " (p) financial loss;",
  " (q) reputational loss;",
  " (r) hospitalization costs;",
  " (s) indirect loss;",
  " (t) incidental damages;",
  " (u) punitive damages;",
  " (v) consequential damages;",
  " (w) medical complications;",
  " (x) delayed treatment outcomes;",
  " (y) psychological impact;",
  " (z) adverse pregnancy outcomes;",
  "whether arising directly or indirectly from:",
  " (i) use of the Platform;",
  " (ii) inability to use the Platform;",
  " (iii) AI-generated responses;",
  " (iv) expert interactions;",
  " (v) wellness activities;",
  " (vi) tracking analysis;",
  " (vii) community discussions;",
  " (viii) delayed medical consultation;",
  " (ix) inaccurate data entered by the User;",
  " (x) technical interruptions;",
  " (xi) internet failures;",
  " (xii) cyber incidents;",
  " (xiii) third-party service failures.",
  "5.2 The User expressly acknowledges that pregnancy inherently carries medical risks, including risks to maternal health, fetal health, delivery outcomes, and neonatal outcomes, irrespective of use of the Platform.",
  "5.3 Nothing available on the Platform guarantees:",
  " (a) safe pregnancy;",
  " (b) safe delivery;",
  " (c) healthy childbirth;",
  " (d) maternal survival;",
  " (e) fetal survival;",
  " (f) prevention of complications;",
  " (g) absence of congenital defects;",
  " (h) absence of developmental disorders;",
  " (i) emotional wellbeing outcomes.",
  "⸻",
  "6. AI ASSISTANT DISCLAIMER",
  "6.1 The AI Pregnancy Assistant is an automated informational technology tool and does not constitute medical advice, diagnosis, prescription, treatment, emergency management, or healthcare supervision.",
  "6.2 AI-generated responses may be inaccurate, incomplete, delayed, generalized, outdated, medically unsuitable, or inconsistent.",
  "6.3 The User shall independently verify all AI-generated information with qualified healthcare professionals prior to acting upon such information.",
  "6.4 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall bear no liability arising from reliance upon AI-generated outputs.",
  "⸻",
  "7. GARBHASANSKAR & WELLNESS DISCLAIMER",
  "7.1 Garbhasanskar activities, meditation, yoga, breathing exercises, music, wellness activities, stories, emotional support content, and relaxation practices are voluntary wellness activities intended solely for emotional wellbeing and maternal engagement purposes.",
  "7.2 Participation in such activities shall be at the sole discretion and risk of the User.",
  "7.3 Users with high-risk pregnancies, placenta previa, severe hypertension, preterm labor risk, cardiac disease, gestational diabetes complications, cervical incompetence, bleeding disorders, multiple pregnancies, or medically complicated pregnancies must consult their treating doctor prior to participating in any wellness activity available on the Platform.",
  "⸻",
  "8. COMMUNITY GUIDELINES & PLATFORM MISUSE",
  "8.1 Users shall not:",
  " (a) post abusive content;",
  " (b) spread misinformation;",
  " (c) engage in harassment;",
  " (d) upload unlawful content;",
  " (e) post sexually explicit material;",
  " (f) impersonate another person;",
  " (g) violate intellectual property rights;",
  " (h) misuse communication systems;",
  " (i) engage in fraudulent activity;",
  " (j) upload harmful software or malware;",
  " (k) misuse expert communication services.",
  "8.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves absolute and unrestricted rights to:",
  " (a) monitor activity;",
  " (b) remove content;",
  " (c) suspend accounts;",
  " (d) permanently terminate Users;",
  " (e) restrict access;",
  " (f) report activity to authorities;",
  " (g) initiate legal proceedings;",
  " (h) cooperate with law enforcement agencies;",
  " (i) preserve records for investigation purposes.",
  "8.3 The Company reserves sole discretion to determine whether any activity constitutes misuse, harmful conduct, suspicious activity, reputational harm, policy violation, unlawful conduct, or platform abuse.",
  "⸻",
  "9. DATA PRIVACY & DPDP COMPLIANCE",
  "9.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall process personal data in accordance with applicable Indian laws including the Digital Personal Data Protection Act, 2023.",
  "9.2 User data may be collected, processed, analyzed, transferred, stored, retained, and used for:",
  " (a) service delivery;",
  " (b) analytics;",
  " (c) AI improvement;",
  " (d) safety monitoring;",
  " (e) customer support;",
  " (f) wellness tracking;",
  " (g) fraud prevention;",
  " (h) legal compliance;",
  " (i) internal operational purposes.",
  "9.3 The User acknowledges that no electronic platform, server, cloud infrastructure, transmission channel, or cybersecurity framework can guarantee absolute data security.",
  "9.4 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be liable for unauthorized access, hacking, data theft, cyberattacks, malware attacks, phishing attacks, data leaks, system intrusions, or third-party security breaches beyond reasonable control.",
  "⸻",
  "10. THIRD-PARTY SERVICES",
  "10.1 The Platform may integrate third-party tools, cloud providers, APIs, payment gateways, analytics systems, communication systems, or technical infrastructure providers.",
  "10.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be responsible for failures, interruptions, privacy practices, inaccuracies, delays, losses, or damages arising from third-party systems or services.",
  "⸻",
  "11. FORCE MAJEURE",
  "11.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be liable for delay, interruption, or failure in performance resulting from events beyond reasonable control including natural disasters, cyberattacks, internet failures, governmental actions, pandemics, server outages, power failures, war, strikes, civil disturbances, or technical failures.",
  "⸻",
  "12. INDEMNIFICATION",
  "12.1 The User agrees to indemnify, defend, and hold harmless REMEDINART MEDICO SERVICES PRIVATE LIMITED, Myprega , its directors, employees, experts, consultants, affiliates, and representatives from any claims, proceedings, liabilities, damages, losses, penalties, legal costs, investigations, or expenses arising out of:",
  " (a) User misconduct;",
  " (b) violation of these Terms;",
  " (c) misuse of the Platform;",
  " (d) inaccurate information submitted by the User;",
  " (e) reliance on AI-generated responses;",
  " (f) failure to seek medical care;",
  " (g) unlawful conduct by the User.",
  "⸻",
  "13. GOVERNING LAW & DISPUTE RESOLUTION",
  "13.1 These Terms shall be governed by the laws of India.",
  "13.2 Any dispute arising from use of the Platform shall first be attempted to be resolved through arbitration in accordance with the Arbitration and Conciliation Act, 1996.",
  "13.3 Courts located in Maharashtra, India shall have exclusive jurisdiction.",
  "⸻",
  "14. MODIFICATION RIGHTS",
  "14.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves unrestricted rights to modify, suspend, discontinue, restrict, or update any part of the Platform, services, policies, Terms & Conditions, or features at any time without prior notice.",
  "14.2 Continued use of the Platform after such modification shall constitute deemed acceptance of revised Terms.",
  "⸻",
  "15. ACCEPTANCE OF TERMS",
  "15.1 By clicking “I Agree,” registering, accessing, or continuing to use the Platform, the User confirms that:",
  " (a) the User has read and understood these Terms;",
  " (b) the User voluntarily accepts all risks associated with pregnancy and platform usage;",
  " (c) the User understands the limitations of AI and digital healthcare support systems;",
  " (d) the User consents to processing of personal and health-related data;",
  " (e) the User releases REMEDINART MEDICO SERVICES PRIVATE LIMITED from liabilities to the maximum extent permissible under applicable law.",
  "    16. SUBSCRIPTION, BILLING & PAYMENTS",
  "16.1 The Platform may offer paid subscription plans, premium features, wellness programs, expert support services, educational content, AI-assisted services, and other digital offerings on a subscription or fee-based model.",
  "16.2 Subscription fees shall be payable in advance and in accordance with the pricing displayed on the Platform at the time of purchase.",
  "16.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves the unrestricted right to modify subscription plans, pricing, inclusions, features, benefits, durations, and service offerings at any time without prior notice.",
  "16.4 Access to paid or premium services may be suspended, restricted, or terminated in the event of payment failure, chargeback, payment reversal, suspected fraud, or violation of applicable policies.",
  "16.5 Users shall be solely responsible for providing accurate billing, payment, and account information.",
  "16.6 All payment processing may be facilitated through third-party payment gateways and financial service providers. The Company shall not be responsible for failures, delays, interruptions, inaccuracies, unauthorized transactions, or technical issues attributable to such third-party providers.",
  "16.7 All refunds, cancellations, payment disputes, and subscription-related matters shall be governed by the Refund & Cancellation Policy, which forms an integral part of these Terms & Conditions.",
  "    17. NO DOCTOR-PATIENT OR HEALTHCARE RELATIONSHIP",
  "17.1 Use of the Platform, AI Assistant, expert support features, wellness activities, communication systems, educational content, tracking features, or community interactions shall not create a doctor-patient relationship, hospital-patient relationship, physician supervision relationship, fiduciary medical relationship, emergency care obligation, or continuing medical supervision relationship between the User and REMEDINART MEDICO SERVICES PRIVATE LIMITED or any person associated with the Platform.",
  "17.2 The User acknowledges that all healthcare decisions remain solely between the User and the User’s treating healthcare professionals.",
  "    18. NO MEDICAL GUARANTEE",
  "18.1 REMEDINART MEDICO SERVICES PRIVATE LIMITED does not guarantee any pregnancy outcome, maternal outcome, fetal outcome, childbirth outcome, emotional outcome, medical outcome, healthcare outcome, wellness outcome, developmental outcome, or neonatal outcome.",
  "18.2 Pregnancy complications, fetal abnormalities, congenital defects, developmental disorders, miscarriage, stillbirth, premature birth, maternal complications, hospitalization, emergency medical situations, neonatal complications, and other adverse outcomes may occur despite use of the Platform.",
  "    19. PLATFORM AVAILABILITY DISCLAIMER",
  "19.1 The Company does not guarantee uninterrupted, continuous, secure, error-free, or always-available operation of the Platform.",
  "19.2 The Platform may be unavailable due to maintenance activities, software updates, technical issues, cybersecurity incidents, internet disruptions, server failures, force majeure events, or third-party service interruptions.",
  "19.3 The Company shall not be liable for losses, damages, interruptions, delays, or inconvenience resulting from Platform unavailability.",
  "    20. DATA BACKUP & RECORD RESPONSIBILITY",
  "20.1 Users remain solely responsible for maintaining independent copies of medical records, prescriptions, reports, scans, investigations, treatment records, and healthcare documentation.",
  "20.2 The Platform shall not be treated as the sole repository of medical information.",
  "20.3 REMEDINART MEDICO SERVICES PRIVATE LIMITED shall not be responsible for losses arising from deletion, corruption, unavailability, technical failure, or loss of User data beyond reasonable control.",
  "    21. REPUTATIONAL PROTECTION",
  "21.1 Users shall not publish, circulate, transmit, post, or disseminate false, misleading, malicious, defamatory, abusive, manipulated, or reputationally harmful statements, allegations, reviews, content, or communications concerning REMEDINART MEDICO SERVICES PRIVATE LIMITED, MyPrega, its founders, directors, employees, experts, consultants, affiliates, partners, healthcare personnel, or services.",
  "21.2 The Company reserves the right to pursue civil, criminal, injunctive, compensatory, or other legal remedies available under applicable law.",
  "    22. USER-GENERATED CONTENT",
  "22.1 Users remain solely responsible for any content, messages, discussions, comments, images, videos, files, opinions, recommendations, or information shared through community features or communication systems available on the Platform.",
  "22.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED does not endorse, verify, validate, guarantee, or assume responsibility for any user-generated content.",
  "22.3 The Company reserves the unrestricted right to review, moderate, remove, restrict, archive, or preserve user-generated content at its sole discretion.",
  "    23. TELECOMMUNICATION & DIGITAL SUPPORT LIMITATIONS",
  "23.1 Users acknowledge that digital communication, expert support, messaging systems, AI interactions, educational guidance, and wellness support may be limited by absence of physical examination, incomplete medical history, inability to perform diagnostic testing, delayed response times, technical interruptions, communication failures, or emergency limitations.",
  "23.2 Users shall not rely upon digital interactions as a substitute for physical medical consultation or emergency healthcare services.",
  "    24. AGE RESTRICTION",
  "24.1 The Platform is intended solely for individuals who are eighteen (18) years of age or older.",
  "24.2 REMEDINART MEDICO SERVICES PRIVATE LIMITED reserves the right to suspend, restrict, verify, or terminate accounts suspected to belong to minors.",
  "    25. ACCOUNT DELETION & DATA REMOVAL",
  "25.1 Users may request deletion of their account through the Platform or designated support channels.",
  "25.2 Upon successful verification of the request, the Company shall take reasonable steps to delete, anonymize, or de-identify personal and health-related data associated with the User.",
  "25.3 Notwithstanding Clause 25.2, the Company may retain certain information where required for:",
  " (a) compliance with applicable law;",
  " (b) regulatory obligations;",
  " (c) dispute resolution;",
  " (d) fraud prevention;",
  " (e) cybersecurity investigations;",
  " (f) audit requirements;",
  " (g) payment verification;",
  " (h) enforcement of legal rights;",
  " (i) legitimate business and operational purposes.",
  "25.4 Following deletion, certain anonymized, aggregated, non-identifiable, or legally required records may continue to be retained in accordance with applicable laws and Company policies.",
  "",
  "",
  "",
];

function TermsOfUseAppSection() {
  return (
    <section className="pt-4">
      <h2 className="text-center fw-bold py-4 my-4 text-uppercase border-top border-bottom border-3">
        TERMS & CONDITIONS
      </h2>
      {termsOfUseAppParagraphs.map((paragraph, index) => {
        if (paragraph === "") {
          return <br key={index} />;
        }

        if (paragraph === "⸻") {
          return (
            <p key={index} className="text-center my-3">
              {paragraph}
            </p>
          );
        }

        return <p key={index}>{paragraph}</p>;
      })}
    </section>
  );
}

export default TermsOfUseAppSection;
